import Component from 'flarum/Component';
export default class ChatWelcome extends Component {
  view(vnode) {
    return m("div", null, m("div", {
      className: "wrapper",
      style: {
        height: app.chat.getFrameState('transform').y + 40 + 'px'
      }
    }, app.chat.getChats().length ? m("div", {
      className: "welcome"
    }, m("h1", null, app.translator.trans('flatrate-live-chat.forum.chat.welcome.header')), m("span", null, app.translator.trans('flatrate-live-chat.forum.chat.welcome.subheader'))) : null));
  }
}
flarum.reg.add('flatrate-live-chat', 'forum/components/ChatWelcome', ChatWelcome);